import { ApplicationRef, inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, first, interval } from 'rxjs';
import { ENVIRONMENT } from '../environment/environment.config';
import { Environment } from '../environment/environment.model';
import { FlashMessagesService } from '../modules/flash-messages/flash-messages.service';

@Injectable({providedIn: 'root'})
export class ServiceWorkerService {
    private appRef = inject(ApplicationRef);
    private environment = inject<Environment>(ENVIRONMENT);
    private flashes = inject(FlashMessagesService);
    private updates = inject(SwUpdate);

    init(): void {
        if ('development' === this.environment.name || !this.updates.isEnabled) {
            return;
        }

        const appIsStable$ = this.appRef.isStable.pipe(first(isStable => true === isStable));
        const everyThreeHour$ = interval(3 * 3600000); // Every 3 hour
        const everyThreeHoursOnceAppIsStable$ = concat(appIsStable$, everyThreeHour$);

        everyThreeHoursOnceAppIsStable$.subscribe(() => {
            this.updates.checkForUpdate()
                .then(value => {
                    if (true === value) {
                        this.flashes.info(
                            'Mise à jour de l\'application',
                            `L'application a été mise à jour. Vous devez rafraîchir la page pour obtenir les dernières nouveautés !<br>
                            Cliquez sur la notification pour mettre à jour.`,
                            {
                                autohide: false,
                                callback: () => document.location.reload(),
                            });
                    }
                });
        });
    }
}
